export default __webpack_public_path__ + "static/media/remove-circle-black-24px.5d24d11c.svg";